import React from "react"
import Badge from "@kit/design/badge"

export const PaidFeatureBadge = ({ className = "ml-2" }) => {
  return (
    <Badge
      color="blue"
      variant="light"
      size="sm"
      className={`${className} whitespace-nowrap bg-blue-100 text-blue-800`}
    >
      Paid feature
    </Badge>
  )
}
